import React from "react";

import classNames from "classnames";

import styles from "./style.module.scss";

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  bare?: boolean;
  variant?: "link" | "danger";
};

const Button: React.FunctionComponent<Props> = ({
  className,
  bare,
  variant,
  children,
  ...rest
}) => {
  const baseStyle = !bare && styles.outlineBtn;
  const linkColorStyle =
    variant === "link"
      ? "!text-link hover:!text-link-hover focus:!text-link-focus"
      : variant === "danger"
      ? "!text-[#d43f3a] hover:!text-[#ac2925] focus:!text-[#ac2925]"
      : undefined;
  return (
    <button
      className={classNames(
        baseStyle,
        linkColorStyle,
        // Overrides the variant's color, which otherwise hides that it's disabled
        variant && "disabled:!text-[#999] disabled:cursor-not-allowed",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
